// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"528":"d516157e","599":"f285fb24"}[chunkId] + ".css";
};